import type { RootState } from "../types/store.types";

export const selectResponseJson = (state: RootState) => state.apiReport?.responseJson;
